export const pageEventsConfig = {
    parentSelector: 'body',
    events: {
        // Breadcrumb link click
        breadcrumbClick: {
            selector: 'ol.breadcrumb__list a.full-unstyled-link',
            event: {
                event: 'user_interaction',
                component: 'breadcrumb',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const spanElement = element.querySelector('span[itemprop="name"]');
                    return {
                        link_text: spanElement ? spanElement.textContent.trim() : element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Back to top button click
        backToTopClick: {
            selector: 'button.back-to-top',
            event: {
                event: 'user_interaction',
                component: 'back_top_top',
                element: 'button',
                action: 'click',
                trigger: 'click'
            }
        }
    }
}; 